export enum SolutionType {
  UTD = "utd",
  SPEC = "spec",
  IFC = "ifc",
}

export const SOLUTION_TYPES_LIST = Object.values(SolutionType)
